import React from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import BenefitsSection from './components/BenefitsSection';
import TestimonialCard from './components/TestimonialCard';

const Login = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <>
      <Helmet>
        <title>Sign In - HungryElph | Authentic Home-Cooked Meals</title>
        <meta 
          name="description" 
          content="Sign in to HungryElph to order delicious home-cooked meals or start selling your culinary creations. Secure authentication for customers and suppliers." 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
            <div className="order-2 lg:order-1">
              <div className="mb-8 md:mb-10 lg:mb-12">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                    <Icon name="ChefHat" size={28} color="var(--color-primary)" />
                  </div>
                  <span className="text-2xl md:text-3xl font-heading font-bold text-foreground">
                    HungryElph
                  </span>
                </div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
                  Welcome Back
                </h1>
                <p className="text-base md:text-lg text-muted-foreground">
                  Sign in to access your dashboard and continue your culinary journey
                </p>
              </div>

              <BenefitsSection />

              <div className="mt-8 md:mt-10 lg:mt-12">
                <TestimonialCard />
              </div>

              <div className="mt-8 md:mt-10">
                <SecurityBadges />
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="bg-card rounded-2xl shadow-warm-lg p-6 md:p-8 lg:p-10 sticky top-8">
                <div className="mb-8">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">
                    Sign In
                  </h2>
                  <p className="text-sm md:text-base text-muted-foreground">
                    Enter your credentials to access your account
                  </p>
                </div>

                <LoginForm />

                <div className="mt-8 pt-6 border-t border-border">
                  <p className="text-center text-sm text-muted-foreground mb-4">
                    New to HungryElph?
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <a
                      href="/register"
                      className="flex items-center justify-center gap-2 px-4 py-3 bg-muted hover:bg-muted/80 rounded-lg transition-smooth"
                    >
                      <Icon name="ShoppingBag" size={18} />
                      <span className="text-sm font-medium">Join as Customer</span>
                    </a>
                    <a
                      href="/register"
                      className="flex items-center justify-center gap-2 px-4 py-3 bg-muted hover:bg-muted/80 rounded-lg transition-smooth"
                    >
                      <Icon name="Store" size={18} />
                      <span className="text-sm font-medium">Join as Supplier</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer className="mt-12 md:mt-16 lg:mt-20 pt-8 border-t border-border">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-sm text-muted-foreground">
                &copy; {currentYear} HungryElph. All rights reserved.
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
                <a href="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                  Privacy Policy
                </a>
                <a href="/terms" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                  Terms of Service
                </a>
                <a href="/support" className="text-sm text-muted-foreground hover:text-primary transition-smooth">
                  Support
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Login;